import { render } from "./productChart.vue?vue&type=template&id=5dbf7edd"
import script from "./productChart.vue?vue&type=script&lang=js"
export * from "./productChart.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__